module.exports = __webpack_public_path__ + "static/fonts/Mont-ExtraLightItalic.412a200.ttf";